import { useTranslate } from "@tolgee/react";
import Alert from 'react-bootstrap/Alert';
import { useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";

export const HasBeenPublishedWarning = () => {
    const { t } = useTranslate();

    const hasBeenPublished = useSelector(
        (state: lomavisCreatorRootState) => state.lomavisCreator?.has_been_published
    );

    const importing_post = useSelector(
        (state: lomavisCreatorRootState) => state.lomavisCreator?.lomavisCreatorConfig?.importing_post
    );

    return (
        hasBeenPublished && !importing_post ? (
            <div className="d-flex w-100 bg-white p-1 shadow rounded">
                <Alert className="w-100 text-center mb-0 text-dark" variant="success">
                    {t("lomavisCreator.hasBeenPublishedWarning")}
                </Alert>
            </div>
        ) : null
    );
};
